import { formatMessageIntlUtil } from '../../../intl'
import getMusclesCombinationMessageWorkoutUtil from '../get-muscles-combination-message'

export default function getMusclesCombinationStringWorkoutUtil (muscles, intl) {
  const messageObj = getMusclesCombinationMessageWorkoutUtil({ muscles })
  return formatMessageIntlUtil(intl, messageObj.message, messageObj.params)
}
